import { useState } from "react";
import { List, Card, Space, Typography } from "antd";
import "./ClanakCardsKorisnik.css";
import { useNavigate } from "react-router-dom";
import { formatDateTime } from "../../utils/formatDateTime";
import "../Dokument/DokumentCardsKorisnik.css";
import StatistikaClankaService from "../../services/statistikaClanka.service";
import dayjs from "dayjs";
import logoDark from "../../img/logo_dark.png";

const { Text } = Typography;

function ClanakCardsKorisnik({ clanci, onDeleteClick, onEditClick }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentClanci = clanci.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(clanci.length / itemsPerPage);

  const handleClickClanak = async (clanakId) => {
    const novaStatistika = {
      //   vremenskaOznaka: new Date().toISOString(),
      vremenskaOznaka: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
      clanakId: clanakId,
    };

    try {
      await StatistikaClankaService.addStatistikaClanka(novaStatistika);
    } catch (error) {}

    navigate(`/clanci/${clanakId}`);
  };

  return (
    <List
      grid={{ gutter: 16, xs: 1, sm: 1, md: 3, lg: 4, xl: 4, xxl: 4 }}
      dataSource={currentClanci}
      locale={{ emptyText: "Nema dostupnih članaka." }}
      style={{ marginTop: "10px", marginBottom: "0px" }}
      renderItem={(clanak, index) => {
        const colors = ["#c9bc8d", "#f7eba8", "#babd7d", "#ded6a0"];
        const backgroundColor = colors[index % colors.length];
        return (
          <List.Item>
            <div className="document-cards">
              <Card
                hoverable
                onClick={() => handleClickClanak(clanak.id)}
                cover={
                  <div
                    className="dokument-card-cover"
                    style={{ backgroundColor, padding: "0", lineHeight: "0" }}
                  >
                      <img
                      src={clanak.slika ? clanak.slika : logoDark}
                      alt="Slika"
                      className="clanak-card-img-korisnik"
                      style={{
                        backgroundColor,
                        objectFit: clanak.slika ? "cover" : "scale-down",
                      }}
                    />
                  </div>
                }
              >
                <div className="dokument-card-title">{clanak.naslov}</div>
                <Space className="dokument-card-footer" align="center" size={4}>
                  <Text type="secondary">
                    {formatDateTime(clanak.datumObjave)}
                  </Text>
                </Space>
              </Card>
            </div>
          </List.Item>
        );
      }}
    >
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Prethodna
          </button>

          <span>
            Stranica {currentPage} od {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Sljedeća
          </button>
        </div>
      )}
    </List>
  );
}
export default ClanakCardsKorisnik;
